import React from 'react';
// import ReactDOM from 'react-dom/client'; // v18 syntax
import ReactDOM from 'react-dom';
import { App } from "./App.js";
import { render } from 'react-dom';
import 'react-html5-camera-photo/build/css/index.css';
import './custom.scss';

import "process";
import { performMonkeyPatches } from './util/monkeypatches.js';
import { installNativeUtilities } from './util/nativeUtils.js';
window.process = process;  // Needed by React PDF plugin - for some reason WebPack ProvidePlugin not working

// Add any standard monkey-patches we need
performMonkeyPatches();

// Add extras needed for native apps
installNativeUtilities();

// React v17
let rootElem = document.getElementById("root");
render(<React.StrictMode>
	<App />
</React.StrictMode>, rootElem);

/*
// React v18
const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

*/
